import { Form, Offcanvas } from "react-bootstrap";
import DonutChart from "../Chart/DonutChart";
import BoxPlotChart from "../Chart/BoxPlotChart";
import SimplePieChart from "../Chart/SimplePieChart";
import MultipleRadialbarsChart from "../Chart/MultipleRadialbarsChart";
import ProgressChart from "../Chart/ProgressChart";
import BarChart from "../Chart/BarChart";
import GroupedBarChart from "../Chart/GroupedBarChart";
import GroupedStackBarChart from "../Chart/GroupedStackBarChart";
import StackedColumnsChart from "../Chart/StackedColumnsChart";
import StackBarChart from "../Chart/StackBarChart";
import ColumnChart from "../Chart/ColumnChart";
import GroupedColumnChart from "../Chart/GroupedColumnChart";

const AddStandardGraph = ({
    actionType,
    subjectDataBy,
    setSubjectDataBy,
    subjectDataValue,
    setSubjectDataValue,
    graphName,
    setGraphName,
    graphType,
    setGraphType,
    yAxisName,
    setYAxisName,
    xAxisName,
    setXAxisName,
    siteType,
    chartType,
    setChartType,
    setColorOptions,
    colorOptions,
    handleStandardColorChange
}) => {

    const donutChart = {
        totalData: [44, 55, 41, 17, 15],
        totalCategory: ["Site A", "Site B", "Site C", "Site D", "Site E"],
    };

    const simplePieChart = {
        totalData: [25, 15, 44, 55, 41],
        totalCategory: ["Screened", "Randomized", "Discontinued", "Completed", "Ongoing"],
    };

    const progressChart = {
        totalData: [70],
        mainData: 50,
        remainingData: 20,
        title: "Total Subjects",
        mainTitle: "Screened Subjects",
        remainingTitle: "Remaining Subjects",
        resultData: 70,
    };

    const multipleRadialbarsChart = {
        totalData: [30, 40, 45, 50, 49, 60],
        totalCategory: ["Site A", "Site B", "Site C", "Site D", "Site E", "Site F"],
    };

    const barChart = {
        totalData: [30, 40, 45, 50, 49, 60],
        totalCategory: ["Site A", "Site B", "Site C", "Site D", "Site E", "Site F"],
    };

    const groupedBarChart = {
        totalData: [
            { name: "Screened", data: [30, 40, 45, 50, 49, 60] },
            { name: "Randomized", data: [20, 35, 40, 30, 44, 52] },
        ],
        totalCategory: ["Site A", "Site B", "Site C", "Site D", "Site E", "Site F"],
    };

    const stackBarChart = {
        totalData: [
            { name: "Screened", data: [30, 40, 45, 50, 49, 60] },
            { name: "Randomized", data: [20, 35, 40, 30, 44, 52] },
            { name: "Discontinued", data: [15, 25, 30, 35, 40, 45] },
        ],
        totalCategory: ["Site A", "Site B", "Site C", "Site D", "Site E", "Site F"],
    };

    const columnChart = {
        totalData: [30, 40, 45, 50, 49, 60],
        totalCategory: ["Site A", "Site B", "Site C", "Site D", "Site E", "Site F"],
    };

    const groupedColumnChart = {
        totalData: [
            { name: "Screened", data: [30, 40, 45, 50, 49, 60] },
            { name: "Randomized", data: [20, 35, 40, 30, 44, 52] },
        ],
        totalCategory: ["Site A", "Site B", "Site C", "Site D", "Site E", "Site F"],
    };

    const stackedColumnsChart = {
        totalData: [
            { name: "Screened", data: [30, 40, 45, 50, 49, 60] },
            { name: "Randomized", data: [20, 35, 40, 30, 44, 52] },
            { name: "Discontinued", data: [15, 25, 30, 35, 40, 45] },
        ],
        totalCategory: ["Site A", "Site B", "Site C", "Site D", "Site E", "Site F"],
    };

    return (
        <>
            {actionType === "category" &&
                <>
                    <Form.Group className="mb-1">
                        <Form.Label className="fw-bold mb-1">
                            Subject Criteria{" "}
                            <abbr title="Required" className="text-danger">
                                *
                            </abbr>
                        </Form.Label>
                        <Form.Select
                            onChange={(e) => { setSubjectDataBy(e.target.value); setChartType(""); setGraphType("") }}
                            className="br3"
                            style={{ fontSize: 12 }}
                        >
                            <option selected={subjectDataBy === ""} value="">Select Subject Criteria</option>
                            <option selected={subjectDataBy === "screenStatus"} value="screenStatus">Screen Status</option>
                            <option selected={subjectDataBy === "randomizationStatus"} value="randomizationStatus">Randomization Status</option>
                            <option selected={subjectDataBy === "discontinueStatus"} value="discontinueStatus">Discontinue Status</option>
                            <option selected={subjectDataBy === "completedStatus"} value="completedStatus">Completed Status</option>
                        </Form.Select>
                    </Form.Group>
                    {subjectDataBy &&
                        <Form.Group className="mb-1">
                            <Form.Label className="fw-bold mb-1">
                                Subject Criteria Value{" "}
                                <abbr title="Required" className="text-danger">
                                    *
                                </abbr>
                            </Form.Label>
                            <Form.Select
                                onChange={(e) => { setSubjectDataValue(e.target.value); setChartType(""); setGraphType("") }}
                                className="br3"
                                style={{ fontSize: 12 }}
                            >
                                <option selected={subjectDataValue === ""} value="">Select Subject Criteria Value</option>
                                <option selected={subjectDataValue === "allStatus"} value="allStatus">All Status</option>
                                {subjectDataBy === "screenStatus" ?
                                    <>
                                        <option selected={subjectDataValue === "pass"} value="pass">Screen Passed</option>
                                        <option selected={subjectDataValue === "fail"} value="fail">Screen Failed</option>
                                    </>
                                    : subjectDataBy === "randomizationStatus" ?
                                        <>
                                            <option selected={subjectDataValue === "yes"} value="yes">Randomization Yes</option>
                                            <option selected={subjectDataValue === "no"} value="no">Randomization No</option>
                                        </>
                                        : subjectDataBy === "discontinueStatus" ?
                                            <>
                                                <option selected={subjectDataValue === "yes"} value="yes">Discontinue Yes</option>
                                                <option selected={subjectDataValue === "no"} value="no">Discontinue No</option>
                                            </>
                                            : subjectDataBy === "completedStatus" &&
                                            <>
                                                <option selected={subjectDataValue === "yes"} value="yes">Complition Yes</option>
                                                <option selected={subjectDataValue === "no"} value="no">Complition No</option>
                                            </>
                                }
                            </Form.Select>
                        </Form.Group>
                    }
                </>
            }
            {actionType === "graph" &&
                <>
                    <div className="border-end">
                        <div className="button____group hstack">
                            {(siteType === "overAll" && subjectDataValue === "allStatus") &&
                                <>
                                    <button
                                        onClick={() => setGraphType("donutGraph")}
                                        className={`w-100 text-nowrap text-center py-2 border fontSize12 ${graphType === "donutGraph" ? "activeChartType" : ""
                                            }`}
                                    >
                                        Donut Graph
                                    </button>
                                    <button
                                        onClick={() => setGraphType("paiGraph")}
                                        className={`w-100 text-nowrap text-center py-2 border fontSize12 ${graphType === "paiGraph" ? "activeChartType" : ""
                                            }`}
                                    >
                                        Pai Graph
                                    </button>
                                </>
                            }
                            {siteType === "siteWise" &&
                                <button
                                    onClick={() => setGraphType("barColumnGraph")}
                                    className={`w-100 text-nowrap text-center py-2 border fontSize12 ${graphType === "barColumnGraph" ? "activeChartType" : ""
                                        }`}
                                >
                                    Bar/Column Graph
                                </button>
                            }
                            {(siteType !== "siteWise") &&
                                <>
                                    <button
                                        onClick={() => setGraphType("progressBar")}
                                        className={`w-100 text-nowrap text-center py-2 border fontSize12 ${graphType === "progressBar" ? "activeChartType" : ""
                                            }`}
                                    >
                                        Progress Bar
                                    </button>
                                </>
                            }
                            {(subjectDataValue !== "allStatus" && siteType === "siteWise") &&
                                <button
                                    onClick={() => setGraphType("radialBar")}
                                    className={`w-100 text-nowrap text-center py-2 border fontSize12 ${graphType === "radialBar" ? "activeChartType" : ""
                                        }`}
                                >
                                    Radial Bar
                                </button>
                            }
                        </div>
                    </div>
                    {graphType ? (
                        <div className="w-100">
                            {graphType === "donutGraph" &&
                                <div className="doughtnutClass">
                                    <DonutChart graph={donutChart} />
                                </div>
                            }
                            {graphType === "paiGraph" &&
                                <div className="doughtnutClass">
                                    <SimplePieChart graph={simplePieChart} />
                                </div>
                            }
                            {graphType === "progressBar" &&
                                <div className="doughtnutClass">
                                    <ProgressChart graph={progressChart} />
                                </div>
                            }
                            {graphType === "radialBar" &&
                                <div className="doughtnutClass">
                                    <MultipleRadialbarsChart graph={multipleRadialbarsChart} />
                                </div>
                            }
                            {graphType === "boxPlot" &&
                                <div className="doughtnutClass">
                                    <BoxPlotChart />
                                </div>
                            }
                            <div className="p-2">
                                {graphType === "barColumnGraph" &&
                                    <>
                                        <Form.Group className="mb-1">
                                            <Form.Label className="fw-bold mb-1">
                                                Chart Type{" "}
                                                <abbr title="Required" className="text-danger">
                                                    *
                                                </abbr>
                                            </Form.Label>
                                            <Form.Select
                                                onChange={(e) => setChartType(e.target.value)}
                                                className="br3"
                                                style={{ fontSize: 12 }}
                                            >
                                                <option selected={chartType === ""} value="">Select Chart</option>
                                                {subjectDataValue !== "allStatus" &&
                                                    <option selected={chartType === "bar"} value="bar">Bar Chart</option>
                                                }
                                                {subjectDataValue === "allStatus" &&
                                                    <>
                                                        <option selected={chartType === "groupedBar"} value="groupedBar">Grouped Bar Chart</option>
                                                        <option selected={chartType === "stackBar"} value="stackBar">Stack Bar Chart</option>
                                                    </>
                                                }
                                                {subjectDataValue !== "allStatus" &&
                                                    <option selected={chartType === "column"} value="column">Column Chart</option>
                                                }
                                                {subjectDataValue === "allStatus" &&
                                                    <>
                                                        <option selected={chartType === "groupColumn"} value="groupColumn">Grouped Column Chart</option>
                                                        <option selected={chartType === "stackColumn"} value="stackColumn">Stacked Column Chart</option>
                                                    </>
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <>
                                            {chartType &&
                                                <Form.Label className="fw-bold mt-3">
                                                    Example Graph
                                                </Form.Label>
                                            }
                                        </>
                                    </>
                                }
                                {graphType === "barColumnGraph" &&
                                    <>
                                        {chartType === "bar" &&
                                            <div className="doughtnutClass">
                                                <BarChart graph={barChart} />
                                            </div>
                                        }
                                        {chartType === "groupedBar" &&
                                            <div className="doughtnutClass">
                                                <GroupedBarChart graph={groupedBarChart} />
                                            </div>
                                        }
                                        {chartType === "stackBar" &&
                                            <div className="doughtnutClass">
                                                <StackBarChart graph={stackBarChart} />
                                            </div>
                                        }
                                        {chartType === "groupedStackBar" &&
                                            <div className="doughtnutClass">
                                                <GroupedStackBarChart />
                                            </div>
                                        }
                                        {chartType === "column" &&
                                            <div className="doughtnutClass">
                                                <ColumnChart graph={columnChart} />
                                            </div>
                                        }
                                        {chartType === "groupColumn" &&
                                            <div className="doughtnutClass">
                                                <GroupedColumnChart graph={groupedColumnChart} />
                                            </div>
                                        }
                                        {chartType === "stackColumn" &&
                                            <div className="doughtnutClass">
                                                <StackedColumnsChart graph={stackedColumnsChart} />
                                            </div>
                                        }
                                        {chartType === "groupStackColumn" &&
                                            <div className="doughtnutClass">
                                                <StackedColumnsChart />
                                            </div>
                                        }
                                    </>
                                }
                                {(subjectDataBy === "screenStatus" && subjectDataValue === "allStatus") &&
                                    colorOptions.map((item, idx) => (
                                        <div key={idx} className="hstack gap-2">
                                            <Form.Control
                                                className="mb-2 border-0 rounded-0 p-0 mt-1"
                                                style={{ width: 25, height: 13 }}
                                                type="color"
                                                value={item.color}
                                                onChange={(e) => handleStandardColorChange(idx, e.target.value)}
                                            />
                                            <Form.Label className="fw-bold mb-1">{item.option}</Form.Label>
                                        </div>
                                    ))
                                }
                                <Form.Group className="mb-1">
                                    <Form.Label className="fw-bold mb-1">
                                        Graph Name{" "}
                                        <abbr title="Required" className="text-danger">
                                            *
                                        </abbr>
                                    </Form.Label>
                                    <Form.Control
                                        className="mb-2"
                                        type="text"
                                        value={graphName}
                                        onChange={(e) => setGraphName(e.target.value)}
                                        placeholder="Graph Name"
                                    />
                                </Form.Group>
                                {graphType === "barColumnGraph" && (
                                    <>
                                        <Form.Group className="mb-1">
                                            <Form.Label className="fw-bold mb-1">
                                                Y-Axis Name{" "}
                                                <abbr title="Required" className="text-danger">
                                                    *
                                                </abbr>
                                            </Form.Label>
                                            <Form.Control
                                                className="mb-2"
                                                type="text"
                                                value={yAxisName}
                                                onChange={(e) => setYAxisName(e.target.value)}
                                                placeholder="Y-Axis Name"
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-1">
                                            <Form.Label className="fw-bold mb-1">
                                                X-Axis Name{" "}
                                                <abbr title="Required" className="text-danger">
                                                    *
                                                </abbr>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                className="mb-2"
                                                value={xAxisName}
                                                onChange={(e) => setXAxisName(e.target.value)}
                                                placeholder="X-Axis Name"
                                            />
                                        </Form.Group>
                                    </>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="p-4 text-center">Select Graph type</div>
                    )}
                </>
            }
        </>
    );
};

export default AddStandardGraph;
